// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, AuthService, Login } from '../../../../core/auth';
import {AuthhService } from './../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/user.service';
/**
 * ! Just example => Should be removed in development
 */
// const DEMO_PARAMS = {
// 	EMAIL: 'admin@demo.com',
// 	PASSWORD: 'demo'
// };

const DEMO_PARAMS = {
	EMAIL: '',
	PASSWORD: ''
};



@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];
	userid
	//token:any=[];

	private unsubscribe: Subject<any>;

	private returnUrl: any;

	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private auth: AuthService,
		private login: AuthhService,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private userService: UserService
	) {
		this.unsubscribe = new Subject();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		localStorage.clear();
		this.initLoginForm();

		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params.returnUrl || '/';
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			const initialNotice = `Use account
			<strong>${DEMO_PARAMS.EMAIL}</strong> and password
			<strong>${DEMO_PARAMS.PASSWORD}</strong> to continue.`;
			this.authNoticeService.setNotice(initialNotice, 'info');
		}

		// this.loginForm = this.fb.group({
		// 	email: [DEMO_PARAMS.EMAIL, Validators.compose([
		// 		Validators.required,
		// 		Validators.email,
		// 		Validators.minLength(3),
		// 		Validators.maxLength(320) 
		// 	])
		// 	],
		// 	password: [DEMO_PARAMS.PASSWORD, Validators.compose([
		// 		Validators.required,
		// 		Validators.email,
		// 		Validators.minLength(3),
		// 		Validators.maxLength(320) 
		// 	])]
	
			
		// });

		this.loginForm = this.fb.group({
			email: [DEMO_PARAMS.EMAIL, Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: [DEMO_PARAMS.PASSWORD, Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			]
		});


	}

	/**
	 * Form Submit
	 */
	
	 submit() {
			const controls = this.loginForm.controls;
			if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		  }
		    this.loading = true;
		    const authData = {
			email: controls.email.value,
			password: controls.password.value
	   	    };
		    this.login
		 	.login(authData).subscribe(
	 		res=>{
			// console.log('access-token'+res.token);
			if (res) {
				// debugger;

				//console.log();
			  localStorage.setItem('username', res['user'].username);
			  localStorage.setItem('email', res['user'].email);
			  localStorage.setItem('priceStatus', res['user'].priceStatus);
			  localStorage.setItem('userId', res['user'].uuid);
			//  console.log('vgfhjwebruigreu',res['user'].username);
			  ///this.store.dispatch(new Login({authToken: res.token}));
			//this.store.dispatch(new Login({authToken: res?.token}));
			this.store.dispatch(new Login({authToken: res["token"]}));
		    //   this.store.dispatch(new Login({authToken: 'access-token-8f3ae836da744329a6f93bf20594b5cc'}));

			// debugger;
			this.authNoticeService.setNotice(this.translate.instant(authData.email+" "+'Logged in successfully'), 'success');
			this.router.navigateByUrl(this.returnUrl); // Main page
			this.toastr.success('Logged in successfully!');	
			this.userid = localStorage.getItem('userId');
			this.userService.loginUser(this.userid)
			}
			else{

      	   this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');

			}


		    },
			err => {
				console.log(err);
				if (err && err.error && err.error.error) {
				  this.toastr.error(err.error.error, 'Error');
				} else {
				  this.toastr.error('An unexpected error occurred.', 'Error');
				}
			  }
			)
			.add(() => {
			  this.loading = false;
			});
		}


	// submit() {
	// 	const controls = this.loginForm.controls;
	// 	/** check form */
	// 	if (this.loginForm.invalid) {
	// 		Object.keys(controls).forEach(controlName =>
	// 			controls[controlName].markAsTouched()
	// 		);
	// 		return;
	// 	}

	// 	this.loading = true;

	// 	const authData = {
	// 		email: controls.email.value,
	// 		password: controls.password.value
	// 	};
	// 	this.auth
	// 		.login(authData.email, authData.password)
	// 		.pipe(
	// 			tap(user => {
	// 				if (user) {
	// 					this.store.dispatch(new Login({authToken: user.accessToken}));
    //               		//console.log(user.accessToken);
	// 					 this.router.navigateByUrl(this.returnUrl); // Main page
	// 				} else {
	// 					this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
	// 				}
	// 			}),
	// 			takeUntil(this.unsubscribe),
	// 			finalize(() => {
	// 				this.loading = false;
	// 				this.cdr.markForCheck();
	// 			})
	// 		)
	// 		.subscribe();
	// }



	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}
}
